import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Zone from "@frog/source/models/Zone.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Keyb from "keyb"
import Tilesetter from "@frog/source/models/admin/Tilesetter.js"
import {nanoid} from "nanoid"

import Objdict from "objdict"

export default class DevSelection {
    constructor() {
        this.z = 1
        this.drag = {}
    }
    update() {
        if(Keyb.wasJustPressed("T")) {
            this.z += 1
        }
        if(Keyb.wasJustPressed("G")) {
            this.z = 1
        }
        if(Keyb.wasJustPressed("B")) {
            this.z -= 1
        }

        this.selection = App.game.chapter.selection

        const hoveredSpot = Object.values(Dev.loadedProtostage.world.spots).find((spot) => {
            return spot.position.x == this.selection.position.x
                && spot.position.y == this.selection.position.y
        })
        if(hoveredSpot != undefined) {
            this.hoveredSpotKey = hoveredSpot.key
        } else {
            this.hoveredSpotKey = undefined
        }

        let hoveredEncounter = Object.values(Dev.loadedProtostage.world.zones).find((zone) => {
            return zone.points.find((vertex) => {
                    return vertex.x == this.selection.position.x + 0.5
                        && vertex.y == this.selection.position.y + 0.5
                })
        }) || Object.values(Dev.loadedProtostage.world.zones).find((zone) => {
            return Zone.isInBounds(zone, this.selection.position)
        })
        if(hoveredEncounter != undefined) {
            this.hoveredEncounterKey = hoveredEncounter.key
        } else {
            this.hoveredEncounterKey = undefined
        }

        const hoveredVertex = hoveredEncounter?.points.find((vertex) => {
            return vertex.x == this.selection.position.x + 0.5
                && vertex.y == this.selection.position.y + 0.5
        })
        if(hoveredVertex != undefined) {
            this.hoveredVertexKey = hoveredVertex.key
        } else {
            this.hoveredVertexKey = undefined
        }
    }
    start() {
        this.drag.startPosition = {
            "x": Math.ceil(App.game.chapter.selection.position.x),
            "y": Math.ceil(App.game.chapter.selection.position.y),
            "z": this.z,
        }
        if(Dev.mode == "geography") {
        }
    }
    finish() {
        if(Dev.inProtoMode == false) return

        if(Dev.mode == "battle"
        || Dev.mode == "scripts") {
            if(Dev.selectedTemplate != undefined) this.placeNewUnit(this.selection.position)
            if(this.selectedSpotTemplate != undefined) {
                Dev.saveToUndo()
                const newKey = nanoid().slice(0,5)
                Dev.loadedProtostage.world.spots[newKey] = {
                    "position": {
                        "x": this.selection.position.x,
                        "y": this.selection.position.y,
                        "z": 1,
                    },
                    "key": newKey,
                    "tag": this.selectedSpotTemplate.tag
                }

                if(this.selectedSpotTemplate.tag == "path"
                && this.selectedSceneStep?.body != undefined) {
                    this.selectedSceneStep.body = this.selectedSceneStep.body + " " + newKey
                    //Dev.reparseScript()
                }
            }
        } else if(Dev.mode == "geography") {
            const x = Math.ceil(this.selection.position.x)
            const y = Math.ceil(this.selection.position.y)
            const z = this.z

            function addTileToBlock({position, tileTemplate}) {
                const blocks = Dev.loadedProtostage.world.blocks
                const slug = position.x + "x" + position.y + "x" + position.z + (tileTemplate.channelKey == undefined ? "" : "_" + tileTemplate.channelKey)
                const changedTile = {
                    "position": {"x": position.x, "y": position.y, "z": position.z},
                    "size": {"x": 1, "y": 1, "z": 1},
                    "hasCollision": tileTemplate.hasCollision || false,
                    "tileKey": tileTemplate.key || 0,
                    "channelKey": tileTemplate.channelKey,
                }
                blocks[slug] = changedTile
            }
            if(this.selectedTileTemplate != undefined) {
                Dev.saveToUndo()
                if(this.drag.startPosition.x != x
                || this.drag.startPosition.y != y) {
                    for(let boxedX = Math.min(x, this.drag.startPosition.x); boxedX <= Math.max(x, this.drag.startPosition.x); boxedX++) {
                        for(let boxedY = Math.min(y, this.drag.startPosition.y); boxedY <= Math.max(y, this.drag.startPosition.y); boxedY++) {
                            addTileToBlock({
                                "position": {"x": boxedX, "y": boxedY, "z": z},
                                "tileTemplate": this.selectedTileTemplate
                            })
                        }
                    }
                } else {
                    addTileToBlock({
                        "position": {"x": x, "y": y, "z": z},
                        "tileTemplate": this.selectedTileTemplate
                    })
                }
                Dev.loadedProtostage.images = Tilesetter.drawEnvironment({"world": Dev.loadedProtostage.world})
            }
            if(this.selectedEncounterAsset == "rectangle") {
                Dev.saveToUndo()
                const width = 3
                const height = 3
                const stampPoints = [
                    {"x": x, "y": y},
                    {"x": x + width, "y": y},
                    {"x": x + width, "y": y + height},
                    {"x": x, "y": y + height},
                ]
                const newKey = nanoid().slice(0,5)
                const newEncounter = {
                    "key": newKey,
                    "slug": newKey,
                    "zoomout": 1.0,
                    "z": z,
                    "points": stampPoints.map((point) => {
                        return {
                            "x": point.x,
                            "y": point.y,
                            "key": nanoid().slice(0,5),
                        }
                    })
                }
                newEncounter.zone = newEncounter
                Dev.loadedProtostage.world.zones[newKey] = newEncounter
            } else if(this.selectedEncounterAsset == "polygon"
                    && (this.hoveredVertexKey == undefined
                    || this.selectedVertexKey != undefined)) {

                Dev.saveToUndo()
                const newVertex = {
                    "x": Math.floor(this.selection.position.x + 0.5),
                    "y": Math.floor(this.selection.position.y + 0.5),
                    "key": nanoid().slice(0,5),
                }
                if(this.selectedEncounterKey != undefined) {
                    if(this.selectedVertexKey != undefined) {
                        const selectedEncounterVertices = Dev.loadedProtostage.world.zones[this.selectedEncounterKey].points
                        const selectedVertexIndex = selectedEncounterVertices.findIndex((point) => point.key == this.selectedVertexKey)
                        selectedEncounterVertices.splice(selectedVertexIndex + 1, 0, newVertex)
                    } else {
                        Dev.loadedProtostage.world.zones[this.selectedEncounterKey].points.push(newVertex)
                    }
                    this.hoveredEncounterKey = this.selectedEncounterKey
                } else {
                    const newKey = nanoid().slice(0,5)
                    const newEncounter = {
                        "key": newKey,
                        "slug": newKey,
                        "zoomout": 1.0,
                        "z": z,
                        "points": [newVertex]
                    }
                    newEncounter.zone = newEncounter
                    Dev.loadedProtostage.world.zones[newKey] = newEncounter
                    this.hoveredEncounterKey = newKey
                }
                this.hoveredVertexKey = newVertex.key
            } else if(this.selectedEncounterAsset == "vertex") {
                Dev.saveToUndo()
                const newVertex = {
                    "x": Math.floor(this.selection.position.x + 0.5),
                    "y": Math.floor(this.selection.position.y + 0.5),
                    "key": nanoid().slice(0,5),
                }

                let closestDistance = 4
                let closestEdge = null
                let closestEncounterKey = null
                Object.values(Dev.loadedProtostage.world.zones).forEach((encounter) => {
                    for(var index = 0; index < encounter.points.length; index++){
                        const currentPoint = encounter.points[index]
                        const beforePoint = index == 0 ? encounter.points[encounter.points.length - 1] : encounter.points[index - 1]

                        const distance = Geometry.distanceFromEdgeBetweenTwoPoints(newVertex, currentPoint, beforePoint)
                        if(distance < closestDistance) {
                            closestDistance = distance
                            closestEdge = {
                                "pointA": beforePoint,
                                "pointB": currentPoint,
                            }
                            closestEncounterKey = encounter.key
                        }
                    }
                })

                if(closestEdge == null) {
                    const newEncounterKey = nanoid().slice(0,5)
                    const newEncounter = {
                        "key": newEncounterKey,
                        "slug": newEncounterKey,
                        "zoomout": 1.0,
                        "z": z,
                        "points": [newVertex]
                    }
                    newEncounter.zone = newEncounter
                    Dev.loadedProtostage.world.zones[newEncounterKey] = newEncounter
                    this.hoveredEncounterKey = newEncounterKey
                } else {
                    const closestEncounterVertices = Dev.loadedProtostage.world.zones[closestEncounterKey].points
                    const closestVertexIndex = closestEncounterVertices.findIndex((point) => point.key == closestEdge.pointB.key)
                    closestEncounterVertices.splice(closestVertexIndex, 0, newVertex)
                    this.hoveredEncounterKey = this.closestEncounterKey
                }
            }
        }

        this.clearSelected()
        this.drag = {}
        if(Dev.mode == "battle" || Dev.mode == "scripts") this.selectedSpotKey = this.hoveredSpotKey
        if(Dev.mode == "geography") {
            this.selectedVertexKey = this.hoveredVertexKey
            this.selectedEncounterKey = this.hoveredEncounterKey
        }

        if(Dev.mode == "scripts"
        && this.selectedSceneStep != undefined
        && (Keyb.isDown("<meta>") == true
        || Keyb.isDown("<control>") == true)) {
            const pastedKey = this.hoveredSpotKey || App.game.chapter?.selection?.hoveredUnitKey || (App.game?.chapter?.selection?.position?.x || 0) + "x" + (App.game?.chapter?.selection?.position?.y || 0)
            if(pastedKey != undefined) {
                this.selectedSceneStep.body = this.selectedSceneStep.body + " " + pastedKey
            }
        }
    }
    get selectedScene() {
        return Dev.loadedScript?.scenes.find((scene) => scene.key == Dev.devSelection.selectedSceneKey)
    }
    get selectedSceneStep() {
        if(this.selectedScene == undefined) return
        function findStepInNestedEventsList(list) {
            let foundStep
            list.forEach((step) => {
                if(step.key == Dev.devSelection.selectedSceneStepKey) foundStep = step
                if(step.eventsList != undefined) foundStep = foundStep || findStepInNestedEventsList(step.eventsList)
            })
            return foundStep
        }
        return findStepInNestedEventsList(this.selectedScene.events.list)
    }
    clearSelected() {
        this.selectedSpotKey = undefined
        this.selectedEncounterKey = undefined
        this.selectedVertexKey = undefined
        this.selectedSavestateReport = undefined
    }
    deleteSelection() {
        if(this.selectedEncounterKey != undefined) {
            Dev.saveToUndo()
            if(this.selectedVertexKey != undefined) {
                const selectedEncounterVertices = Dev.loadedProtostage.world.zones[this.selectedEncounterKey].points
                const selectedVertexIndex = selectedEncounterVertices.findIndex((point) => point.key == this.selectedVertexKey)
                selectedEncounterVertices.splice(selectedVertexIndex, 1)
                const numberOfVertices = selectedEncounterVertices.length
                if(numberOfVertices == 0) {
                    delete Dev.loadedProtostage.world.zones[this.selectedEncounterKey]
                    this.selectedEncounterKey = undefined
                } else {
                    this.selectedVertexKey = selectedEncounterVertices[(selectedVertexIndex + numberOfVertices) % numberOfVertices].key
                }
            } else {
                delete Dev.loadedProtostage.world.zones[this.selectedEncounterKey]
                this.selectedEncounterKey = undefined
            }
        }
    }
    placeNewUnit(position) {
        if(this.selection == undefined) this.selection = App.game.chapter.selection
        if(Dev.selectedTemplate == undefined) return
        const baseUnit = {
            "position": {
                "x": position.x,
                "y": position.y,
                "z": 1
            },
        }
        const newUnit = Objdict.merge(baseUnit,Dev.selectedTemplate)
        Dev.createNewUnit(newUnit)

        this.selection.selectedUnitKey = newUnit.key
        this.selection.clearSelected()
    }
}
